import { List } from "immutable";

import { DatabaseTable, returnID } from "../BaseTable";
import AnchorProperty from "./AnchorProperty";
import { types } from "../../helpers/Util";
import AnchorProperties from "./AnchorProperties";
import { toLowerCaseObject } from "../../helpers/DataUpdateHelper";

class AnchorRaw extends DatabaseTable {
  readonly id: number;
  readonly subject_id: number;
  readonly interaction_id: number;
  readonly external_origin:string | null;
  readonly external_id : string |null ;
  readonly active: boolean;
  readonly final: boolean;
  readonly self_reported :  boolean ;
  readonly date: string;
  readonly time: string;
  public properties: AnchorProperties | any; // TODO - in the future this will be a deeply nested; complicated representation of a model

  static readonly serializableFields = new Map([
    ["id", [types.number]],
    ["subject_id", [types.number]],
    ["interaction_id", [types.number, types.null]],
    ["external_origin", [types.string, types.null]],
    ["external_id", [types.string, types.null]],
    ["active", [types.boolean]],
    ["final", [types.boolean]],
    ["date", [types.string]],
    ["self_reported", [types.boolean]],
    ["timestamp", [types.string, types.null]],
    ["properties", [types.object]],
  ]);
  static readonly tableName = "Anchor";

  constructor(
    id = -1,
    subject_id = -1,
    interaction_id = -1,
    external_origin = null,
    external_id = null,
    active = true,
    final = false,
    self_reported = false,
    date = "",
    time = "",
    properties = new AnchorProperties(),
  ) {
    super();
    this.id = returnID(id);
    this.subject_id = subject_id;
    this.interaction_id = interaction_id;
    this.external_origin = external_origin,
    this.external_id = external_id,
    this.active = active;
    this.final = final;
    this.self_reported = self_reported;
    this.date = date;
    this.time = time;
    this.properties = properties;
  }
}

class Anchor extends AnchorRaw {
  constructor(...args: any[]) {
    super(...args);
  }

  // convert back to singleton js object of format
  // {"Anatomy":"Knee", "Clinician":"Smtih"}
  protected beforeSave(): this {
    const copy = { ...this } as any;
    if ( copy.properties.properties ) {
      copy.properties = Object.fromEntries(copy.properties.properties)
      copy.properties = toLowerCaseObject(copy.properties)
    }
    return copy as typeof this;
  }

  protected async afterSave(oldRecord?: DatabaseTable) {
    const url: string =process.env.REACT_APP_CARESENSE_URL  + "/v2/interactionsEditor/clearAndRerunStudyAssignmentsForPatient?PatientID=" + this.subject_id + "&APIKey=" + process.env.REACT_APP_API_JWT
    const data = {debug:true,PatientID:this.subject_id, APIKey:process.env.REACT_APP_API_JWT}
    
    fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
    }).then(async (data: any) => {
      console.log(data)
    });
  }

}

export default Anchor;
